document.addEventListener('DOMContentLoaded', function () {
  initSvReveal();
  initSvDial();
  initSvTilt();
  initSvParallax();
});

var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function animateTempValue(el, fromText, toText, duration) {
  var fromNum = parseFloat(fromText) || 0;
  var toNum = parseFloat(toText) || 0;
  var suffix = toText.replace(/[0-9.\-]/g, '');
  if (prefersReducedMotion || fromNum === toNum) {
    el.textContent = toText;
    return;
  }
  var start = null;
  function step(timestamp) {
    if (!start) start = timestamp;
    var progress = Math.min((timestamp - start) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    var current = Math.round(fromNum + (toNum - fromNum) * eased);
    el.textContent = current + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

function initSvReveal() {
  var els = document.querySelectorAll('.sv-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('sv-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('sv-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initSvDial() {
  var heroes = document.querySelectorAll('[data-sv-hero]');
  heroes.forEach(function (hero) {
    var swatches = hero.querySelectorAll('.sv-swatch');
    var dial = hero.querySelector('.sv-dial');
    var tint = hero.querySelector('.sv-dial__tint');
    var temp = hero.querySelector('.sv-dial__temp-value');
    var colorNameDial = hero.querySelector('.sv-dial__colorname');
    var colorNameCopy = hero.querySelector('.sv-hero__color-name');
    var priceEl = hero.querySelector('.sv-hero__price');
    var productShot = hero.querySelector('.sv-dial__product-shot img');

    if (!swatches.length || !dial) return;

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        swatch.setAttribute('aria-pressed', 'true');

        var color = swatch.dataset.color;
        var temperature = swatch.dataset.temp;
        var name = swatch.dataset.name;
        var price = swatch.dataset.price;
        var image = swatch.dataset.image;
        var tintOpacity = swatch.dataset.tintOpacity || '0.32';

        dial.style.setProperty('--sv-dial-color', color);
        if (tint) {
          tint.style.setProperty('--sv-dial-color', color);
          tint.style.setProperty('--sv-dial-tint-opacity', tintOpacity);
        }
        if (temp) animateTempValue(temp, temp.textContent, temperature, 500);
        if (colorNameDial) colorNameDial.textContent = name;
        if (colorNameCopy) colorNameCopy.textContent = name;
        if (priceEl && price) priceEl.textContent = price;
        if (productShot && image) productShot.setAttribute('src', image);
      });
    });
  });
}

function initSvTilt() {
  if (prefersReducedMotion || window.matchMedia('(hover: none)').matches) return;
  var cards = document.querySelectorAll('.sv-palette__item');
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.setProperty('--sv-tilt-x', (y * -8).toFixed(2) + 'deg');
      card.style.setProperty('--sv-tilt-y', (x * 8).toFixed(2) + 'deg');
    });
    card.addEventListener('mouseleave', function () {
      card.style.setProperty('--sv-tilt-x', '0deg');
      card.style.setProperty('--sv-tilt-y', '0deg');
    });
  });
}

function initSvParallax() {
  if (prefersReducedMotion) return;
  var media = document.querySelectorAll('.sv-ritual__media');
  if (!media.length) return;
  var ticking = false;
  function update() {
    media.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight;
      var center = rect.top + rect.height / 2;
      var offset = (center - vh / 2) / vh;
      var shift = Math.max(-24, Math.min(24, offset * -32));
      el.style.setProperty('--sv-parallax-y', shift.toFixed(1) + 'px');
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
  update();
}
